import { Sidebar } from 'primereact/sidebar';
import { useState } from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import BrandLogo from '../logo.png';

const SidebarMenu = ({ show, close }) => {
    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [isSignOut, setSignOut] = useState(false);

    return (
        <Sidebar visible={show} onHide={close}>
            <div className='mb-2'>
                <span className="fw-bold fs-12 px-2 py-1 border rounded">{`v${process.env.REACT_APP_VERSION}`}</span>
            </div>
            <Image src={BrandLogo} alt="Brand Logo" style={{ height: '40px' }} className="mb-4" />
            <h5 className="text-muted">Menu</h5>
            <ul className="list-group list-group-flush userMenu border-top">
                <li className="list-group-item fw-bold ps-0">
                    <Link to="/" title="Dashboard" className="nav-link">
                        <span>Dashboard</span>
                    </Link>
                </li>
                {userLogin.role === 'admin' ?
                    <>
                        <li className="list-group-item fw-bold ps-0">
                            <Link to="/customer" title="Data Pelanggan" className="nav-link">
                                <span>Data Pelanggan</span>
                            </Link>
                        </li>
                        <li className="list-group-item fw-bold ps-0">
                            <Link to="/penawaran" title="Data Penawaran" className="nav-link">
                                <span>Data Penawaran</span>
                            </Link>
                        </li>
                        <li className="list-group-item fw-bold ps-0">
                            <Link to="/inspeksi" title="Data Inspeksi" className="nav-link">
                                <span>Data Inspeksi</span>
                            </Link>
                        </li>
                        <li className="list-group-item fw-bold ps-0">
                            <Link to="/invoice" title="Data Tagihan" className="nav-link">
                                <span>Data Tagihan</span>
                            </Link>
                        </li>
                        <li className="list-group-item fw-bold ps-0">
                            <Link to="/pembayaran" title="Data Pemabyaran" className="nav-link">
                                <span>Data Pembayaran</span>
                            </Link>
                        </li>
                        <li className="list-group-item fw-bold ps-0">
                            <Link to="/users" title="Data Pengguna" className="nav-link">
                                <span>Data Pengguna</span>
                            </Link>
                        </li>
                        <li className="list-group-item fw-bold ps-0">
                            <Link to="/options" title="Pengaturan Umum" className="nav-link">
                                <span>Pengaturan Umum</span>
                            </Link>
                        </li>
                        <li className="list-group-item fw-bold ps-0">
                            <Link to="/options/master/brand" title="Master Data Merek" className="nav-link">
                                <span>Master Data Merek</span>
                            </Link>
                        </li>
                        <li className="list-group-item fw-bold ps-0">
                            <Link to="/options/master/type" title="Master Data Type" className="nav-link">
                                <span>Master Data Type</span>
                            </Link>
                        </li>
                    </> :
                    <li className="list-group-item fw-bold ps-0">
                        <Link to="/inspeksi" title="Data Inspeksi" className="nav-link">
                            <span>Data Inspeksi</span>
                        </Link>
                    </li>
                }
                <li className="list-group-item fw-bold ps-0 pb-2 pt-4">
                    <Link to="/account/profile" title="Akun Saya" className="nav-link">
                        <span>Akun Saya</span>
                    </Link>
                </li>
                <li className="list-group-item fw-bold ps-0">
                    <Link to={`#`} onClick={(e) => {
                        window.localStorage.clear();
                        window.location.assign('/login');
                    }} title="Keluar" className="nav-link text-danger">
                        <span>Keluar</span>
                    </Link>
                </li>
            </ul>
        </Sidebar>
    );
}

export default SidebarMenu;
